module.exports = __webpack_public_path__ + "static/media/iconParametre.ab8b23bf.svg";